import { getSubscription } from 'public/Utilities/subscription';
import { applyVisibility } from 'public/Utilities/common';
import { viewMode } from 'wix-window-frontend';

$w.onReady(async function () {

    await checkSubscription();
    let props = $widget.props;
    await handleTitleVisibility(props.showTitle);
    await changeDesign(props.template, props.design);
    await selectBadges(props);
    await handleChangeTextDisplayOption(props);
    await changeTemplate(props.template);
});

$widget.onPropsChanged(async (oldProps, newProps) => {
    let props = $widget.props;
    await handleTitleVisibility(props.showTitle);
    await selectBadges(props);
    await handleChangeTextDisplayOption(props);
    await changeDesign(props.template, props.design);
    await changeTemplate(props.template);
});

async function changeTemplate(template) {
    $w('#multiStateBox1').changeState(`template${template}`);
}

async function changeDesign(template, design) {
    $w(`#template${template}MultiStateBox`).changeState(`template${template}Design${design}`);
}

async function selectBadges(props) {

    let badges = props.badge;
    let selectedBadges = JSON.parse(badges);
    let isAnyBadgesAvailable = selectedBadges.length > 0;
    if (!isAnyBadgesAvailable) return;
    //console.log("selectedBadges : ", selectedBadges);

    const isBadgeIndexAvailable = (templateArray, badgeIndex) => {
        //console.log("isBadgeIndexAvailable : ", templateArray , badgeIndex);
        const index = templateArray.findIndex((item) => item == badgeIndex);
        return index > -1
    }

    $w(`#template${props.template}Design${props.design}Repeater`).forEachItem(($item, itemData, index) => {
        if (isBadgeIndexAvailable(selectedBadges, index + 1)) {
            //console.log("item no expanded : ", (index + 1).toString());
            $item(`#template${props.template}Design${props.design}RepeaterItem`).expand();
        } else {
            //console.log("item no collapsed : ", (index + 1).toString());
            $item(`#template${props.template}Design${props.design}RepeaterItem`).collapse();
        }
    })

}

async function handleChangeTextDisplayOption(props) {
    if(props.textDisplayOption === '1'){
		//console.log("option 1");
		$w(`#template${props.template}Design${props.design}RepeaterTopBox`).expand();
		$w(`#template${props.template}Design${props.design}RepeaterRightText`).collapse();
	} else if(props.textDisplayOption === '2'){
		//console.log("option 2");
		$w(`#template${props.template}Design${props.design}RepeaterTopBox`).collapse();
		$w(`#template${props.template}Design${props.design}RepeaterRightText`).expand();
	} else if (props.textDisplayOption === '3') {
		//console.log("option 3");
		$w(`#template${props.template}Design${props.design}RepeaterTopBox`).collapse();
		$w(`#template${props.template}Design${props.design}RepeaterRightText`).collapse();
	} else {
        console.log("Invalid option");
    }
}

async function handleTitleVisibility(showTitle) {
    if(showTitle){
        $w('#titleBox').expand();
    } else {
        $w('#titleBox').collapse();
    }
}

//function for check subscription
async function checkSubscription() {
    const subscriptionResponse = await getSubscription();
    //console.log("subscriptionResponse: ", subscriptionResponse);
    if (subscriptionResponse) {
        handleFreeTrialBannerVisibility(subscriptionResponse);
        controlOnReadyFunctionsExecution(subscriptionResponse);
    }
}

function handleFreeTrialBannerVisibility(subscriptionResponse) {
    if (viewMode === 'Editor') {
        if (subscriptionResponse.isPremium) {
            $w('#multistateBox-freeTrialBanner').changeState('state-freeTrialEmptyState');
        } else {
            $w('#multistateBox-freeTrialBanner').changeState('state-freeTrialState');
        }
    } else if (viewMode == 'Preview') {
        $w('#multistateBox-freeTrialBanner').changeState('state-freeTrialEmptyState');
    } else {
        $w('#multistateBox-freeTrialBanner').changeState('state-freeTrialEmptyState');
    }
}

function controlOnReadyFunctionsExecution(subscriptionResponse) {
    if (viewMode == 'Editor' || viewMode == 'Preview') {
        applyVisibility('#PaymentMethodsContainer', 'show');
        $w('#PaymentMethodsContainer').expand();
    } else {
        if (subscriptionResponse.isPremium) {
            applyVisibility('#PaymentMethodsContainer', 'show');
            $w('#PaymentMethodsContainer').expand();
        } else {
            applyVisibility('#PaymentMethodsContainer', 'hide');
            $w('#PaymentMethodsContainer').collapse();
        }
    }
}
